import { ReactComponent as Done } from "../../assets/icons/done.svg";
import { ReactComponent as Add } from "../../assets/icons/add.svg";
import { ReactComponent as AttachMoney } from "../../assets/icons/attach_money.svg";
import { ReactComponent as MoneyOff } from "../../assets/icons/money_off.svg";
import { ReactComponent as Route } from "../../assets/icons/route.svg";
import { ReactComponent as Plus } from "../../assets/icons/add-icon.svg";
import { ReactComponent as Question } from "../../assets/icons/question-mark.svg";
import { ReactComponent as ListGray } from "../../assets/icons/list_gray_ic.svg";
import { ReactComponent as Grid } from "../../assets/icons/grid_grey_ic.svg";
import { ReactComponent as Lock } from "../../assets/icons/lock.svg";
import { ReactComponent as Close } from "../../assets/icons/close.svg";
import { ReactComponent as Cancel } from "../../assets/icons/cancel.svg";
import { ReactComponent as SubmittedForm } from "../../assets/icons/submittedForm.svg";
import { ReactComponent as Check } from "../../assets/icons/check.svg";
import { ReactComponent as Phone } from "../../assets/icons/phone.svg";
import { ReactComponent as CloseWhite } from "../../assets/icons/close-white.svg";
import { ReactComponent as CheckedRadio } from "../../assets/icons/checked.svg";
import { ReactComponent as UnCheckedRadio } from "../../assets/icons/unchecked.svg";
import { ReactComponent as CheckOutline } from "../../assets/icons/check_outline_ic.svg";
import { ReactComponent as CheckedIcon } from "../../assets/icons/on.svg";
import { ReactComponent as UncheckedIcon } from "../../assets/icons/off.svg";
import { ReactComponent as Brief } from "../../assets/icons/brief.svg";
import { ReactComponent as AccountDetails } from "../../assets/icons/account_details.svg";
import { ReactComponent as SigningPreferences } from "../../assets/icons/signing_preferences.svg";
import { ReactComponent as Channels } from "../../assets/icons/channels.svg";
import { ReactComponent as ValueAddedServices } from "../../assets/icons/value_added_services.svg";
import { ReactComponent as QuestionMarkGray } from "../../assets/icons/question_mark_grey.svg";
import { ReactComponent as Info } from "../../assets/icons/info.svg";
import { ReactComponent as Help } from "../../assets/icons/help.svg";
import { ReactComponent as InfoYellow } from "../../assets/icons/infoYellow.svg";
import { ReactComponent as InfoRed } from "../../assets/icons/infoRed.svg";
import { ReactComponent as ArrowDown } from "../../assets/icons/arrowDown.svg";
import { ReactComponent as ArrowUp } from "../../assets/icons/arrowUp.svg";
import { ReactComponent as ArrowLeft } from "../../assets/icons/arrowLeft.svg";
import { ReactComponent as Error } from "../../assets/images/error.svg";
import { ReactComponent as File } from "../../assets/icons/file.svg";
import { ReactComponent as ArrowRight } from "../../assets/icons/forwardArrow.svg";
import { ReactComponent as AmberDotted } from "../../assets/icons/amberDotted.svg";
import { ReactComponent as CardTravel } from "../../assets/icons/card_travel.svg";
import { ReactComponent as SettingsSuggest } from "../../assets/icons/settings_suggest.svg";
import { ReactComponent as Domain } from "../../assets/icons/domain.svg";
import { ReactComponent as Information } from "../../assets/icons/information.svg";
import { ReactComponent as InActive } from "../../assets/icons/progressbar/inActive.svg";
import { ReactComponent as Active } from "../../assets/icons/progressbar/active.svg";
import { ReactComponent as Completed } from "../../assets/icons/progressbar/completed.svg";
import { ReactComponent as ProgressIcon } from "../../assets/icons/progressbar/progressIconMobile.svg";
import { ReactComponent as Calendar } from "../../assets/icons/calendar.svg";
import { ReactComponent as SuccessStatus } from "../../assets/icons/success-status.svg";
import { ReactComponent as Edit } from "../../assets/icons/edit.svg";
import { ReactComponent as Delete } from "../../assets/icons/delete.svg";
import { ReactComponent as TradingUp } from "../../assets/icons/trading_up.svg";

export const iconComponents = {
  add: Add,
  done: Done,
  plus: Plus,
  question: Question,
  listGray: ListGray,
  grid: Grid,
  lock: Lock,
  close: Close,
  closeWhite: CloseWhite,
  checkedRadio: CheckedRadio,
  unCheckedRadio: UnCheckedRadio,
  checkOutline: CheckOutline,
  checkedIcon: CheckedIcon,
  uncheckedIcon: UncheckedIcon,
  brief: Brief,
  accountDetails: AccountDetails,
  signingPreferences: SigningPreferences,
  channels: Channels,
  valueAddedServices: ValueAddedServices,
  questionMarkGray: QuestionMarkGray,
  info: Info,
  information: Information,
  infoYellow: InfoYellow,
  infoRed: InfoRed,
  arrowDown: ArrowDown,
  error: Error,
  file: File,
  arrowRight: ArrowRight,
  arrowLeft: ArrowLeft,
  amberDotted: AmberDotted,
  cardTravel: CardTravel,
  settingsSuggest: SettingsSuggest,
  domain: Domain,
  inActive: InActive,
  active: Active,
  completed: Completed,
  progressIcon: ProgressIcon,
  calendar: Calendar,
  successStatus: SuccessStatus,
  edit: Edit,
  delete: Delete,
  check: Check,
  phone: Phone,
  cancel: Cancel,
  submittedForm: SubmittedForm,
  arrowUp: ArrowUp,
  help: Help,
  attachMoney: AttachMoney,
  moneyOff: MoneyOff,
  route: Route,
  tradingUp: TradingUp
};

export const ICONS = {
  done: "done",
  plus: "plus",
  question: "question",
  listGray: "listGray",
  grid: "grid",
  lock: "lock",
  close: "close",
  closeWhite: "closeWhite",
  checkedRadio: "checkedRadio",
  unCheckedRadio: "unCheckedRadio",
  checkOutline: "checkOutline",
  checkedIcon: "checkedIcon",
  uncheckedIcon: "uncheckedIcon",
  brief: "brief",
  accountDetails: "accountDetails",
  signingPreferences: "signingPreferences",
  channels: "channels",
  valueAddedServices: "valueAddedServices",
  questionMarkGray: "questionMarkGray",
  info: "info",
  information: "information",
  infoYellow: "infoYellow",
  infoRed: "infoRed",
  arrowDown: "arrowDown",
  arrowLeft: "arrowLeft",
  error: "error",
  file: "file",
  arrowRight: "arrowRight",
  amberDotted: "amberDotted",
  cardTravel: "cardTravel",
  settingsSuggest: "settingsSuggest",
  domain: "domain",
  inActive: "inActive",
  active: "active",
  completed: "completed",
  progressIcon: "progressIcon",
  calendar: "calendar",
  successStatus: "successStatus",
  edit: "edit",
  delete: "delete",
  add: "add",
  check: "check",
  phone: "phone",
  cancel: "cancel",
  submittedForm: "submittedForm",
  arrowUp: "arrowUp",
  help: "help",
  attachMoney: "attachMoney",
  moneyOff: "moneyOff",
  route: "route",
  tradingUp: "tradingUp"
};
